import { ESdChangeReason } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../shared/hoc/with-context";
import { IWithHistoryProp, withHistory } from "../../../shared/hoc/with-history";
import { PureSdComponent } from "../../../shared/pure-sd";
import { KuikaLogo } from "../../design-tools/header/kuika-logo/kuika-logo";
import { UserMenuButton } from "../../design-tools/left-menu/user-menu-button";
import { WorkspaceSwitcher } from "./workspace-switcher";
import "./management-top-bar.scss";

export interface IManagementTopBarState {}

export interface IManagementTopBarProps {}

type ManagementTopBarAllProps = IManagementTopBarProps & IWithSDProps & IWithContextProp & IWithHistoryProp;

/**
 * Shell header for every management page (Apps, Settings, Cloud, Board, Global
 * Configurations). Brand mark on the far left, then the workspace switcher — the
 * "where am I" element sits on the LEFT, exactly where the designer toolbar puts its
 * workspace/project identity (WorkspaceBranch), so switching shells never moves it.
 * The right identity cluster is the account avatar alone.
 *
 * The switcher used to sit at the top of the left panel and moved here so the two shells
 * (designer and management) present the same row-1 anatomy. Workspace authorization went the
 * other way: it briefly sat in this row as a labelled switch and is back in the account menu
 * (`user-menu-button.tsx`), an owner-only, management-only entry — a workspace-wide setting
 * flipped once in a while does not earn permanent width in the header.
 */
class ManagementTopBar extends PureSdComponent<ManagementTopBarAllProps, IManagementTopBarState> {
  render() {
    return (
      <header className="kuika-management-topbar">
        <div className="kuika-management-topbar__brand">
          <KuikaLogo />
        </div>
        <div className="kuika-management-topbar__left">
          <WorkspaceSwitcher />
        </div>
        <div className="kuika-management-topbar__identity">
          <UserMenuButton />
        </div>
      </header>
    );
  }

  checkNeedRender = (_: ESdChangeReason): boolean => false;
}

const managementTopBar = withContext<IManagementTopBarProps>(
  withHistory<IManagementTopBarProps>(withSD<IManagementTopBarProps>(ManagementTopBar))
);
export { managementTopBar as ManagementTopBar };
